export enum DiscountType {
  Amount = 'amount',
  Percentage = 'percentage',
}
